<template>
  <div class="chart-container" style="position: relative; height:30%; width:98%">
    <canvas ref="temperatureChartEl" width="98%" height="30%">
      <p>Device Temperatures</p>
    </canvas>
  </div>
</template>
<script>
/* eslint-disable */
import Chart from 'chart.js';
import * as ChartAnnotation from 'chartjs-plugin-annotation';
import gql from 'graphql-tag';
import moment from 'moment';
import EventBus from '@/utils/EventBus';

const QUERY_TEMPERATURES = gql`
query query_temperatures($id: String!, $startTime: timestamptz!, $endTime: timestamptz!) {
  temperatures (
    where: {
      _and: [
        {
          device_id: {
            _eq: $id
          }
        },
        {
          timestamp: {
            _gt: $startTime
          }
        },
        {
          timestamp: {
            _lt: $endTime
          }
        }
      ]
    }
    order_by: {
      timestamp: asc
    }
  ) {
    timestamp
    cpu
    gpu
    battery
    ambient
  }
}
`;
const SUBSCRIPTION_TEMPERATURES = gql`
subscription subscription_temperatures($id: String!, $timestamp: timestamptz) {
  temperatures (
    where: {
      device_id: {
        _eq: $id
      }
      timestamp:{
        _gt: $timestamp
      }
    }
    order_by: {
      timestamp: desc
    }
    limit: 1
  ) {
    timestamp
    cpu
    gpu
    battery
    ambient
  }
}
`;

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      cpus: [],
      chartUI: null,
      startTime: this.start,
      endTime: this.end,
      subscription: null,
      showNewValues: true,
    };
  },
  created() {
    EventBus.$on('monitoring-time-changed', this.reCreateChart);
    Chart.plugins.register([ChartAnnotation]); // Global
  },
  beforeDestroy() {
    if (this.chartUI) {
      this.chartUI.destroy();
    }
    EventBus.$off('monitoring-time-changed', this.reCreateChart);
  },
  async mounted() {
    await this.getTemperatures();
    this.createChart();
    // subscribe to new cpu values
    this.subcribeNewTemperatures();
  },
  methods: {
    async reCreateChart(data) {
      this.startTime = data.startTime;
      this.endTime = data.endTime;
      // wait for battery values
      await this.getTemperatures();
      // create chartjs UI
      if (this.chartUI) {
        this.chartUI.destroy();
      }
      this.createChart();
      /*
      if (data.subscribe) {
        console.log('show new values');
      } else {
        this.stopSubscription();
      }
      */
    },
    stopSubscription() {
      console.log('Don\'t show new values');
    },
    async getTemperatures() {
      const result = await this.$apollo.query({
        query: QUERY_TEMPERATURES,
        variables: {
          id: this.id,
          startTime: this.startTime,
          endTime: this.endTime,
        },
      });

      // create values for chartjs
      this.temperatures = result.data.temperatures.map((temp) => ({
        timestamp: new Date(temp.timestamp),
        temperatures: [temp.cpu, temp.gpu, temp.battery, temp.ambient]
      }));
    },
    createChart() {
      // create chartjs UI
      const config = {
        type: 'line',
        data: {
          datasets: []
        },
        options: {
          title: {
					  display: true,
					  text: 'Temperatures (°C)'
				  },
          responsive: true,
          scales: {
            xAxes: [{
              gridLines: {
                color: 'rgba(150, 150, 150, 0.5)'
              },
              type: 'time',
              display: true,
              time: {
                tooltipFormat: 'YYYY-MM-DD HH:mm',
                displayFormats: {
                    millisecond: 'HH:mm:ss.SSS',
                    second: 'HH:mm:ss',
                    minute: 'HH:mm',
                    hour: 'HH'
                },
                unit: 'minute',
                stepSize: 30,
              },
            }],
            yAxes: [{
              gridLines: {
                color: 'rgba(150, 150, 150, 0.5)'
              },
              display: true,
              ticks: {
                beginAtZero: true,
              }
            }]
          },
          annotation: {
            annotations: [{
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: 55,
              borderColor: 'rgb(255, 0, 0)',
              borderWidth: 2,
              borderDash: [2, 2],
            },
            {
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: 80,
              borderColor: 'rgb(255, 0, 0)',
              borderWidth: 2,
              borderDash: [2, 2],
            }]
          }
        }
      };
      const colors = [
        'red',
        'blue',
        'green',
        'cyan',
        'orange',
        'magenta',
        'purple',
        'black'
      ];
      const labels = [
        'CPU',
        'GPU',
        'Battery',
        'Ambient',
      ];
      // Create datasets
      for (let step = 0; step < 4; step++) {
        config.data.datasets.push({
          label: labels[step],
          borderColor: colors[step],
          backgroundColor: colors[step],
          fill: false,
          data: [],
        });
      }

      // Push value based on array index to correct dataset
      this.temperatures.forEach((temp) => {
        const { timestamp } = temp;
        const date = new Date(timestamp);
        if (temp.temperatures) {
          temp.temperatures.forEach((tmp, tmpIndex) => {
            const value = {
              x: date,
              y: tmp,
            };

            config.data.datasets[tmpIndex].data.push(value);
          });
        }
      });

      const { temperatureChartEl } = this.$refs;
      this.chartUI = new Chart(temperatureChartEl, config);
    },
    subcribeNewTemperatures() {
      const { id } = this;
      const that = this;
      const timestamp = new Date().toISOString();

      // start subscribing to new cpu values
      this.$apollo.subscribe({
        query: SUBSCRIPTION_TEMPERATURES,
        variables: {
          id,
          timestamp
        },
      }).subscribe({
          next(data) {
            // got new subscription result
            if (data.data.temperatures.length > 0) {
              // Add new cpu value to chart
              const [temp] = data.data.temperatures;
              const val = {
                timestamp: temp.timestamp,
                temperatures: [temp.cpu, temp.gpu, temp.battery, temp.ambient]
              };
              that.temperatures.push(val);
              that.addData(val);
            }
          },
          error(err) { console.error('err', err); },
      });
    },
    addData(data) {
      // create new value for chartjs
      for (let step = 0; step < 4; step++) {
        const value = {
        x: new Date(data.timestamp),
        y: data.temperatures[step],
      };
        this.chartUI.data.datasets[step].data.push(value);
      }

      // Update chartjs UI
      this.chartUI.update();
    },
  },
};
</script>
<style scoped>
</style>
